<div
   class="dashboard dashboard-background"
   [class.failure-mode]="!(isCommunicationHealthy$ | async)"
   [style.background-image]="(backgroundImage$ | async) ? 'url(' + (backgroundImage$ | async) + ')' : 'initial'"
>
   <samweb-home-bar></samweb-home-bar>
   <samweb-brick-wall [isPilotPanel]="false"></samweb-brick-wall>
   <samweb-pilot-panel
      [class.extended]="isPilotPanelExtended$ | async"
      [ngClass]="(applicationTheme$ | async).alternativeTheme"
   ></samweb-pilot-panel>
</div>
<samweb-queue-selection-dialog></samweb-queue-selection-dialog>
<samweb-accept-or-dial-dialog></samweb-accept-or-dial-dialog>
<samweb-appointment-scheduler-dialog></samweb-appointment-scheduler-dialog>
<samweb-email-dialog *ngFor="let message of openEmailWindows$ | async" [messageId]="message"></samweb-email-dialog>
<samweb-chat-dialog *ngFor="let chatId of openChats$ | async" [chatId]="chatId"></samweb-chat-dialog>

<samweb-directory-editing-dialog *ngFor="let id of directoryEntriesInEditing$ | async" [id]="id">
</samweb-directory-editing-dialog>
<samweb-directory-editing-confirmation-dialog
   *ngFor="let id of directoryEntriesInEditing$ | async"
   [id]="id"
></samweb-directory-editing-confirmation-dialog>
